// The one money formatter for bidder-web. Lives in the shell because both
// features/checkout and shell/components/bids/PayBanner render totals, and
// features may not import each other (see .eslintrc.cjs
// no-cross-feature-import).
//
// Intl, not `(cents / 100).toFixed(2)`: toFixed emits no thousands separator,
// so a $1,573.72 total renders "$1573.72" on the Pay button, and it renders
// negatives as "$-12.34" instead of "-$12.34". Matches
// admin-web/src/features/settlement/format.ts so the two services agree.
const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Whole-dollar variant for informational headline amounts (the PayBanner
// "Charged …" / "Charging …" lines). Rounds, so it must not be used for any figure
// the bidder is asked to act on or to reconcile to the cent: a refund of
// $1,573.72 shown as "$1,574" misstates the amount returned, and a balance shown
// that way on a Check out CTA states more than checkout will charge.
const USD_WHOLE = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export function formatCents(cents: number): string {
  return USD.format((cents ?? 0) / 100);
}

export function formatCentsWhole(cents: number): string {
  return USD_WHOLE.format((cents ?? 0) / 100);
}
